export const CasesQueryKeys = {
  all: ['cases'],
  lists: () => [...CasesQueryKeys.all, 'list'],
  list: (pageParams) => [...CasesQueryKeys.lists(), pageParams],
  details: () => [...CasesQueryKeys.all, 'detail'],
  detail: (id) => [...CasesQueryKeys.details(), id],
};
